import React from 'react';

export default function SinResultados({ query }) {

    return (
        <div className="sin-resultados">
            <span className='icon-search'></span>
            {
                String(query).trim().length === 0
                    ? <span className='text-sin-resultados'>Escriba su búsqueda arriba</span>
                    : <span className='text-sin-resultados'>No se encontraron resultados. Intenta con otras palabras.</span>
            }
        </div>
    );
}
